(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const email = urlParams.get('email');

    if (email) {
      try {
        const emailInput = document.getElementById('CustomerEmail');
        emailInput.value = decodeURIComponent(atob(email));
      } catch {
        // silence is golden
      }
    }
  })();
